import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type {
  CreateNPIListRequest,
  CreateNPIListResponse,
  DownloadNPIsRequest,
  DownloadNPIsResponse,
  GetNpiListsMetadataRequest,
  GetNpiListsMetadataResponse,
  RemoveNPIListRequest,
  RemoveNPIListResponse,
} from './dto';
import { npiListAPIRoutes } from './route';

export const downloadNPIsListAPI = (body: DownloadNPIsRequest): Promise<DownloadNPIsResponse> => {
  return makeRequest(api.post(npiListAPIRoutes.downloadNPIs(), body));
};

export const publishNPIsListAPI = (body: CreateNPIListRequest): Promise<CreateNPIListResponse> => {
  return makeRequest(api.post(npiListAPIRoutes.publishNpiList(), body));
};

export const getNPIListsMetadataAPI = (body: GetNpiListsMetadataRequest): Promise<GetNpiListsMetadataResponse> => {
  return makeRequest(api.post(npiListAPIRoutes.getNPIListMetadata(), body));
};

export const removeNPIListAPI = (body: RemoveNPIListRequest): Promise<RemoveNPIListResponse> => {
  return makeRequest(api.post(npiListAPIRoutes.removeNPIList(), body));
};
